enum Events {
    UPVOTE_GAME = "UPVOTE_GAME",
    UPVOTE_GAME_FULFILLED = "UPVOTE_GAME_FULFILLED",
    FETCH_GAMES = "FETCH_GAMES",
    FETCH_GAMES_FULFILLED = "FETCH_GAMES_FULFILLED",
    FETCH_GAMES_BY_WEEK = "FETCH_GAMES_BY_WEEK",
    FETCH_GAMES_BY_WEEK_FULFILLED = "FETCH_GAMES_BY_WEEK_FULFILLED",
}
export default Events;